<h2 class="!mt-0">
  {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.TITLE' | translate }}

  {{ !name || name == ' ' || name == undefined ? user.attributes?.['phone_number'] : name + ' ' + middle_name }}
</h2>

<div *ngIf="isLoading" class="flex justify-center items-center py-16">
  <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
</div>

<form [formGroup]="createForm" *ngIf="!isLoading">

  <!-- Estructura dinámica basada en isMobile -->
  <div *ngIf="!isMobile" class="grid grid-cols-2 gap-4">
    <!-- Campos para pantallas más grandes (dos columnas) -->

   <!-- Nombre -->
<mat-form-field class="w-full">
  <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.NAME' | translate }}</mat-label>
  <input formControlName="name" type="text" matInput />
  <mat-error *ngIf="createForm.get('name')?.invalid && (createForm.get('name')?.dirty || createForm.get('name')?.touched)">
    {{ 'COMMON.REQUIRED_FIELD' | translate }}
  </mat-error>
</mat-form-field>

<!-- Apellido -->
<mat-form-field class="w-full">
  <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.SURNAME' | translate }}</mat-label>
  <input formControlName="middle_name" type="text" matInput />
  <mat-error *ngIf="createForm.get('middle_name')?.invalid && (createForm.get('middle_name')?.dirty || createForm.get('middle_name')?.touched)">
    {{ 'COMMON.REQUIRED_FIELD' | translate }}
  </mat-error>
</mat-form-field>

<!-- Dirección -->
<mat-form-field class="w-full">
  <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ADDRESS' | translate }}</mat-label>
  <input formControlName="custom:address" type="text" matInput />
  <mat-error *ngIf="createForm.get('custom:address')?.invalid && (createForm.get('custom:address')?.dirty || createForm.get('custom:address')?.touched)">
    {{ 'COMMON.REQUIRED_FIELD' | translate }}
  </mat-error>
</mat-form-field>

<!-- Ciudad -->
<mat-form-field class="w-full">
  <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.CITY' | translate }}</mat-label>
  <input formControlName="custom:ciudad" type="text" matInput />
  <mat-error *ngIf="createForm.get('custom:ciudad')?.invalid && (createForm.get('custom:ciudad')?.dirty || createForm.get('custom:ciudad')?.touched)">
    {{ 'COMMON.REQUIRED_FIELD' | translate }}
  </mat-error>
</mat-form-field>

<!-- Provincia -->
<mat-form-field class="w-full">
  <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.PROVINCE' | translate }}</mat-label>
  <input formControlName="custom:provincia" type="text" matInput />
  <mat-error *ngIf="createForm.get('custom:provincia')?.invalid && (createForm.get('custom:provincia')?.dirty || createForm.get('custom:provincia')?.touched)">
    {{ 'COMMON.REQUIRED_FIELD' | translate }}
  </mat-error>
</mat-form-field>

<!-- Código Postal -->
<mat-form-field class="w-full">
  <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ZIPCODE' | translate }}</mat-label>
  <input formControlName="custom:postcode" type="text" matInput />
  <mat-error *ngIf="createForm.get('custom:postcode')?.invalid && (createForm.get('custom:postcode')?.dirty || createForm.get('custom:postcode')?.touched)">
    {{ 'COMMON.REQUIRED_FIELD' | translate }}
  </mat-error>
</mat-form-field>

<!-- País -->
<!-- <mat-form-field appearance="fill" *ngIf="countriesNames$ | async as countriesNames">
  <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COUNTRY' | translate }}</mat-label>
  <mat-select formControlName="custom:country" [(value)]="selectedCountry" #countrySelect>
    <mat-option>
      <input matInput type="text" placeholder="Search country" [(ngModel)]="countryFilter"
             [ngModelOptions]="{ standalone: true }" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
    </mat-option>
    <mat-option *ngFor="let country of filteredCountries(countries, countriesNames, countryFilter)" [value]="country">
      <span style="display: inline-flex; align-items: center;">
        <img [src]="country | tuiFlag" width="20" height="14" style="margin-right: 8px;" />
        {{ countriesNames[country] }}
      </span>
    </mat-option>
  </mat-select>
  <mat-error *ngIf="createForm.get('custom:country')?.invalid && (createForm.get('custom:country')?.dirty || createForm.get('custom:country')?.touched)">
    {{ 'COMMON.REQUIRED_FIELD' | translate }}
  </mat-error>
</mat-form-field> -->





    <mat-form-field appearance="fill" *ngIf="countriesNames$ | async as countriesNames">
      <mat-label>
        {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COUNTRY' | translate }}
      </mat-label>
      <mat-select
        formControlName="custom:country"
        [(value)]="selectedCountry"
        #countrySelect
      >
        <mat-option>
          <input
            matInput
            type="text"
            placeholder="Search country"
            [(ngModel)]="countryFilter"
            [ngModelOptions]="{ standalone: true }"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          />
        </mat-option>
    
        <mat-option
          *ngFor="let country of filteredCountries(countries, countriesNames, countryFilter)"
          [value]="country"
        >
          <span style="display: inline-flex; align-items: center;">
            <img
              [src]="country | tuiFlag"
              width="20"
              height="14"
              style="margin-right: 8px;"
            />
            {{ countriesNames[country] }}
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    

    <!-- ID -->
  <mat-form-field class="w-full">
    <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ID' | translate }}</mat-label>
    <input formControlName="custom:passport" type="text" matInput />
    <mat-error *ngIf="createForm.get('custom:passport')?.invalid && (createForm.get('custom:passport')?.dirty || createForm.get('custom:passport')?.touched)">
      {{ 'COMMON.REQUIRED_FIELD' | translate }}
    </mat-error>
  </mat-form-field>

  <!-- Email -->
  <mat-form-field class="w-full">
    <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.EMAIL' | translate }}</mat-label>
    <input type="email" formControlName="email" matInput />
    <mat-error *ngIf="createForm.get('email')?.hasError('required') && (createForm.get('email')?.dirty || createForm.get('email')?.touched)">
      {{ 'COMMON.REQUIRED_FIELD' | translate }}
    </mat-error>
    <mat-error *ngIf="createForm.get('email')?.hasError('email') && (createForm.get('email')?.dirty || createForm.get('email')?.touched)">
      {{ 'COMMON.INVALID_EMAIL' | translate }}
    </mat-error>
  </mat-form-field>

  <!-- Teléfono -->
  <mat-form-field class="w-full">
    <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.PHONE' | translate }}</mat-label>
    <input type="tel" formControlName="phone_number" matInput />
    <mat-error *ngIf="createForm.get('phone_number')?.invalid && (createForm.get('phone_number')?.dirty || createForm.get('phone_number')?.touched)">
      {{ 'COMMON.REQUIRED_FIELD' | translate }}
    </mat-error>
  </mat-form-field>

  </div>

  <div *ngIf="isMobile" class="flex flex-col gap-4">
    <!-- Campos para pantallas pequeñas (una columna) -->

    <mat-form-field class="w-full" *ngFor="let field of [
      { label: 'NAME', control: 'name' },
      { label: 'SURNAME', control: 'middle_name' },
      { label: 'ADDRESS', control: 'custom:address' },
      { label: 'CITY', control: 'custom:ciudad' },
      { label: 'PROVINCE', control: 'custom:provincia' },
      { label: 'ZIPCODE', control: 'custom:postcode' },
      { label: 'COUNTRY', control: 'custom:country' },
      { label: 'ID', control: 'custom:passport' },
      { label: 'EMAIL', control: 'email' },
      { label: 'PHONE', control: 'phone_number' }
    ]">
      <mat-label>
      {{ ('COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.' + field.label) | translate }}
    </mat-label>
    <input [formControlName]="field.control" matInput [type]="field.control === 'email' ? 'email' : 'text'" />

    <!-- Validación genérica -->
    <mat-error *ngIf="createForm.get(field.control)?.hasError('required') && (createForm.get(field.control)?.dirty || createForm.get(field.control)?.touched)">
      {{ 'COMMON.REQUIRED_FIELD' | translate }}
    </mat-error>

    <!-- Validación específica para email -->
    <mat-error *ngIf="field.control === 'email' && createForm.get('email')?.hasError('email') && (createForm.get('email')?.dirty || createForm.get('email')?.touched)">
      {{ 'COMMON.INVALID_EMAIL' | translate }}
    </mat-error>
  </mat-form-field>

  </div>

   <!-- Botones -->
  <div class="flex justify-between gap-4 mt-12">
    <app-button expand="full" color="secondary" (click)="goBack()">
      {{ 'COMMON.CANCEL' | translate }}
    </app-button>
    <app-button expand="full" (click)="onUpdate()">
      {{ 'COMMON.CONFIRM' | translate }}
    </app-button>
  </div>

  <div class="loading-mask" *ngIf="globalSpinner">
    <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
  </div>

</form>

<style>
  .grid {
  display: grid;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.gap-4 {
  gap: 16px;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.w-full {
  width: 100%;
}




 .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(
          0,
          0,
          0,
          0.5
        ); /* semi-transparent black background */
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999; /* Ensure it's on top of other content */
      }
</style>


